/**
 * Hook que devuelve la hora actual (ms) y se re-renderiza periódicamente.
 * Útil para que la UI reaccione a fechas de apertura/cierre sin recargar.
 *
 * @param intervalMs Frecuencia de tick (default 30s).
 */
import { useEffect, useState } from "react";

export function useNow(intervalMs = 30_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}
